export const buildPhotosUrl = (
    styleUrlLabel?: string | null,
    roomUrlLabel?: string | null
): string => {
    let photosUrl = '/photos/';

    if (styleUrlLabel) {
        photosUrl += `style/${styleUrlLabel}/`;
    }
    if (roomUrlLabel) {
        photosUrl += `room/${roomUrlLabel}/`;
    }
    return photosUrl;
};
